module.exports = __webpack_public_path__ + "static/media/alexandra-daddario.798b0a6a.jpg";